"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var chat_component_1 = require("./../../components/chat/chat.component");
var adv_detail_component_1 = require("./../../../Adveristments/adv-detail/adv-detail.component");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var conversationService_1 = require("./../../../Services/conversationService");
var service_service_1 = require("./../../../Services/service.service");
var LocalModels_1 = require("./../../../api/LocalModels");
var router_2 = require("@angular/router");
var core_1 = require("@angular/core");
var environment_1 = require("../../../../environments/environment");
var AdvertisementComponent = /** @class */ (function (_super) {
    __extends(AdvertisementComponent, _super);
    function AdvertisementComponent(route, service, conversationService, matDialog, router, renderer) {
        var _this = _super.call(this, route, service, conversationService, matDialog, router) || this;
        _this.route = route;
        _this.service = service;
        _this.conversationService = conversationService;
        _this.matDialog = matDialog;
        _this.router = router;
        _this.renderer = renderer;
        _this.swiperConfig = {
            navigationPlacement: 'inside',
            pagination: true,
            paginationPlacement: 'outside',
            imgBackgroundSize: 'contain'
        };
        _this.galleryImages = [];
        _this.canShowMap = false;
        _this.textInputBarActive = false;
        _this.watchingByAuthor = false;
        _this.isPremium = false;
        service.pageName = "Ad";
        _this.isPremium = _this.service.userService.isPremium();
        return _this;
    }
    ;
    Object.defineProperty(AdvertisementComponent.prototype, "advParam", {
        get: function () {
            return this._advParam;
        },
        set: function (value) {
            this._advParam = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvertisementComponent.prototype, "isUserAdmin", {
        get: function () {
            return this.service.userService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    AdvertisementComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.renderer.listen('window', 'click', function (e) {
            if (_this.btWrite && _this.textInputBar && _this.matDialog.openDialogs.length < 1) {
                if (e.target !== _this.btWrite.nativeElement && !_this.textInputBar.elementRef.nativeElement.contains(e.target) && e.target !== _this.textInputBar.elementRef.nativeElement) {
                    _this.textInputBarActive = false;
                }
            }
        });
    };
    AdvertisementComponent.initEmptyAdvMock = function () {
        var mock = new LocalModels_1.DTOAdvertisementEx();
        mock.title = "";
        mock.content = "";
        mock.images = [];
        return mock;
    };
    AdvertisementComponent.prototype.afterAdvLoad = function () {
        var _this = this;
        if (this.advParam) {
            var currentUserId = this.service.userService.getUserId();
            if (this.advParam.userId == currentUserId) {
                this.watchingByAuthor = true;
            }
            this.conversationService.getActiveConversationId(this.advParam.advertisementId).toPromise().then(function (id) {
                _this.existedConversationId = id;
            });
            this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);
            this.advParam.images = this.advParam.images || [];
            this.advParam.images.sort(function (a, b) {
                return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
            });
            this.advParam.images.forEach(function (v) {
                _this.galleryImages.push(environment_1.environment.apiBaseUrl + "/FileGet/" + v.fileName + "/800x600");
            });
            if (this.advParam.location && this.advParam.location != "") {
                var location_1 = this.advParam.location.split("/").map(function (str) { return parseFloat(str); });
                if (location_1.length == 2) {
                    this.canShowMap = true;
                    this.lat = location_1[0];
                    this.lng = location_1[1];
                }
            }
            if (!this.canShowMap) {
                this.service.advService
                    .getLocationDataByZipCode(this.advParam.zipCode)
                    .toPromise()
                    .then(function (v) {
                    try {
                        if (v.results[0] && v.results[0].geometry.location.lat) {
                            _this.canShowMap = true;
                            _this.lat = v.results[0].geometry.location.lat;
                            _this.lng = v.results[0].geometry.location.lng;
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                });
            }
        }
    };
    AdvertisementComponent.prototype.resolveAdvTitle = function (advParam) {
        if (!advParam) {
            return "";
        }
        else
            return advParam.title || '';
    };
    Object.defineProperty(AdvertisementComponent.prototype, "Location", {
        get: function () {
            if (!this.advParam.isDemo) {
                return (this.advParam.subRegionName || this.advParam.regionShortName) ? (this.advParam.subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "")) : "";
            }
            else {
                var subRegionName = this.advParam.subRegionName;
                if (subRegionName && subRegionName.trim() != "") {
                    return subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "");
                }
                else {
                    var currentLocation = this.service.cookieService.get("current_location_text");
                    if (currentLocation) {
                        return currentLocation.split(",")[0];
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    AdvertisementComponent.prototype.markCurrentAdvertisementAsSeenIfNecessary = function (adv) {
        var _this = this;
        if (this.service.userService.isAuthenticated() && (this.service.userService.isDemo() || this.service.userService.isAdmin()) && adv.isDemo == false && (adv.seen == false || adv.seenAdmin == false)) {
            this.service.advService.markAdvertisementAsSeen(adv.advertisementId, this.isUserAdmin).then(function (res) {
                _this.advParam.seen = true;
                var index = _this.service.advService.searchDataStandard.resultList.findIndex(function (i) { return i.advertisementId == adv.advertisementId; });
                if (index > -1) {
                    if (_this.service.userService.isDemo()) {
                        _this.service.advService.searchDataStandard.resultList[index].seen = true;
                    }
                    if (_this.service.userService.isAdmin()) {
                        _this.service.advService.searchDataStandard.resultList[index].seenAdmin = true;
                    }
                }
            }).catch(function (err) {
                return _this.service.showError(err);
            });
        }
    };
    AdvertisementComponent.prototype.showTextInputBar = function () {
        this.textInputBarActive = true;
    };
    AdvertisementComponent.prototype.editAdv = function (id) {
        this.service.route.navigate(["adv-edit/" + id]);
    };
    return AdvertisementComponent;
}(adv_detail_component_1.AdvDetailComponent));
exports.AdvertisementComponent = AdvertisementComponent;
